import { gql } from '@apollo/client';

export const FETCH_DIVISION_SELECTION = gql`
  query DivisionSelectionDashboard {
    divisionDashBoard {
      fGLocations
      l1Locations
      l2Locations
      l3PlusLocations
      locations {
        capacity
        capacityUnit
        city
        country
        employeeCount
        locationAddress
        locationName
        locationType
        rebuildCost
        rebuildTime
        state
        street
        uuid
        zipCode
      }
      name
      percentage
      uuid
    }
  }
`;

export const CREATE_DEPENDENCY_MATRIX = gql`
  mutation CreateDependencyMatrix($input: CreateDependencyInput!) {
    createDependencyMatrix(input: $input) {
      location {
        capacity
        capacityUnit
        city
        country
        employeeCount
        locationAddress
        locationName
        locationType
        rebuildCost
        rebuildTime
        state
        street
        uuid
        zipCode
      }
      locationAux {
        capacity
        capacityUnit
        city
        country
        employeeCount
        locationAddress
        locationName
        locationType
        rebuildCost
        rebuildTime
        state
        street
        uuid
        zipCode
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const REFRESH_DEPENDENCIES = gql`
  query RefreshDependencies {
    updateMissingDependencies
  }
`;
